import { SessionResponse } from '@api/models';

import logger from '@toolkit/utils/edgeLogger';
import { ApiClient } from '@website/lib/api';

/**
 * Fetches the current user session from the API.
 * Includes error handling and logging.
 *
 * @returns The SessionResponse object if successful, otherwise null.
 */
export const getSession = async (): Promise<SessionResponse | null> => {
  try {
    const session = await ApiClient.getSession();
    return session;
  } catch (error) {
    // A failed session fetch is expected when the user is not signed in (401).
    // Only log at debug level to avoid noisy errors in dev mode.
    logger.debug('Failed to fetch session:', error);
    return null;
  }
};
